import SubscribeButton from './SubscribeButton';
import SubscribeButtonContainer from './SubscribeButton.container';
export default SubscribeButtonContainer(SubscribeButton);
